import { createTheme } from '@mui/material/styles';

export const customTheme = createTheme({
    typography: {
        fontFamily: "Gilroy",
    },
    components: {
        MuiDateCalendar: {
            styleOverrides: {
                root: {
                    ".MuiPickersDay-root": {
                        "&:not(.Mui-selected)": {
                            "&:hover": { backgroundColor: "#FFFBF4" },
                        }

                    },
                    // ".MuiPickersDay-root": {
                    //   "&:not(.Mui-selected)": { border: "1px solid red" }
                    // }
                }
            }
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    fontFamily: 'Gilroy',
                    fontWeight: '600',
                    left: "50%",
                    position: "sticky",
                    top: "10px",
                    transition: "opacity 0.5s ease-in-out",
                    opacity: 1,
                    zIndex: 5,
                    width: "max-content",
                    boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.2)",
                    transform: "translateX(-50%)"
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: "12px",
                    backgroundColor: "#F5F0E7",
                    marginTop: "6px",
                    padding: "0",
                    ".MuiMenu-list": {
                        padding: "0px",
                    },
                    ".MuiMenuItem-root.Mui-selected": {
                        backgroundColor: "transparent",
                        color: "#EE7A45",
                        "&:hover": { backgroundColor: "#FFFBF4" }
                    },
                    ".MuiMenuItem-root": {
                        "&:hover": { backgroundColor: "#FFFBF4" },
                        fontFamily: "Gilroy",
                        fontWeight: "500",
                        lineHeight: "40px",
                    }
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontFamily: 'Gilroy',
                    fontWeight: '500',
                    color: "#6b6b6b",
                    "&:focus": {
                        color: "#6b6b6b",
                    },
                    ".Mui-focused": {
                        color: "#6b6b6b",
                    },
                    ".MuiInputLabel-formControl.Mui-focused": {
                        color: "#6b6b6b",
                    }
                },
            }
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    fontFamily: 'Gilroy',
                    fontWeight: '400',
                    ".MuiInputBase-root.MuiFilledInput-root": {
                        borderRadius: "12px",
                        backgroundColor: "#F5F0E7",
                    },
                    ".MuiSelect-root": {
                        borderRadius: "12px",
                        backgroundColor: "#F5F0E7",
                        fontSize: "26px",
                    },
                    ".MuiFormLabel-root.Mui-focused": {
                        color: "#6b6b6b",
                    },
                },
            }
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    ".MuiInputBase-root": {
                        borderRadius: "12px",
                        border: "none",
                        backgroundColor: "#F5F0E7",
                        "&:focus": {
                            outline: "solid #dbceb7"
                        }
                    },
                    ".MuiInputBase-root.Mui-focused": {
                        outline: "solid #dbceb7"
                    },
                    ".MuiFormLabel-root": {
                        fontFamily: 'Gilroy',
                        fontWeight: '500',
                        color: "#6b6b6b",
                    },
                    ".MuiFormLabel-root.Mui-focused": {
                        color: "#6b6b6b",
                    },
                    ".MuiInputBase-input": {
                        fontFamily: 'Gilroy',
                        fontSize: '16px',
                        fontWeight: 400,
                        lineHeight: '20.8px',
                    },
                    ".MuiFormHelperText-root": {
                        marginRight: 0,
                    }
                },
            },
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    ".MuiSlider-thumb": {
                        backgroundColor: '#EE7A45',
                        '&:hover': {
                            boxShadow: "0 0 0px 8px rgba(238, 122, 69, 0.16)",
                        },
                        '&::before': {
                            content: "unset",
                            boxShadow: "0 0 0px 8px rgba(238, 122, 69, 0.16)",
                        },
                        '&:active': {
                            boxShadow: "0 0 0px 14px rgba(238, 122, 69, 0.16)",
                        },
                    },

                    ".Mui-focusVisible": {
                        "boxShadow": "0 0 0px 8px rgba(238, 122, 69, 0.16)"
                    },

                    ".MuiSlider-markLabel": {
                        fontFamily: 'Gilroy',
                        color: '#999895',
                        fontSize: '16px',
                        fontWeight: 600,
                        lineHeight: '28px'
                    },
                    ".MuiSlider-valueLabel": {
                        backgroundColor: "#F5F0E7",
                        boxShadow: "0 0 8px #35393340",
                        fontFamily: 'Gilroy',
                        fontSize: '16px',
                        fontWeight: 500,
                        lineHeight: '20.8px',
                        color: '#000000',
                        '&:before': {
                            display: 'none',
                        }
                    },
                    ".MuiSlider-track": {
                        backgroundColor: '#EE7A45',
                        border: "none"
                    },
                    ".MuiSlider-rail": {
                        backgroundColor: '#EE7A45',
                    },
                    ".MuiSlider-mark": {
                        display: 'none',
                    },
                }

            },
        },
    }
})